import { create } from 'zustand';
import { fetchData } from '../services/api';

export interface Project {
  id: number;
  name: string;
  client: string;
  status: 'In Progress' | 'Planning' | 'Completed';
  startDate: string;
  endDate: string;
  contractType: string;
  totalHours: number;
  resourceCount: number;
  description: string;
}

interface ProjectStore {
  projects: Project[];
  isLoading: boolean;
  error: string | null;
  selectedProject: Project | null;
  setSelectedProject: (id: number) => void;
  fetchProjects: () => Promise<void>;
  getProjectById: (id: number) => Project | undefined;
  createProject: (project: Omit<Project, 'id'>) => void;
}

const projectData: Project[] = [
  {
    id: 1,
    name: 'Identity Federation Hub',
    client: 'TechCorp Industries',
    status: 'In Progress',
    startDate: '2023-08-01',
    endDate: '2023-12-31',
    contractType: 'Time & Materials',
    totalHours: 2400,
    resourceCount: 4,
    description: 'Implementation of a centralized identity federation system to streamline authentication across multiple platforms and services.'
  },
  {
    id: 2,
    name: 'Zero Trust Implementation',
    client: 'SecureBank Global',
    status: 'Planning',
    startDate: '2023-09-01',
    endDate: '2024-03-31',
    contractType: 'Fixed Price',
    totalHours: 3200,
    resourceCount: 6,
    description: 'Enterprise-wide implementation of Zero Trust security architecture with comprehensive access control and monitoring.'
  },
  {
    id: 3,
    name: 'IAM System Upgrade',
    client: 'Healthcare Plus',
    status: 'Completed',
    startDate: '2023-07-15',
    endDate: '2023-10-15',
    contractType: 'Time & Materials',
    totalHours: 1600,
    resourceCount: 3,
    description: 'Upgrade and modernization of existing Identity and Access Management systems to support new compliance requirements.'
  }
];

export const useProjectStore = create<ProjectStore>((set) => ({
  projects: projectData,
  isLoading: false,
  error: null,
  selectedProject: null,
  setSelectedProject: (id: number) => {
    const project = projectData.find(p => p.id === id) || null;
    set({ selectedProject: project });
  }, 
  getProjectById: (id: number) => projectData.find(p => p.id === id),
  fetchProjects: async () => {
    set({ isLoading: true, error: null });
    try {
      const data = await fetchData(projectData);
      set({ projects: data, isLoading: false });
    } catch (error) {
      set({ error: (error as Error).message, isLoading: false });
    }
  },
  createProject: (project) => set((state) => ({
    projects: [...state.projects, { ...project, id: state.projects.length + 1 }]
  }))
}));